import useMountEffect from '@restart/hooks/useMountEffect';
import React, { useState, useRef } from 'react';

const ModalContainer = () => {
  const modal = useRef({ component: null, props: null });
  const [, forceUpdate] = useState();

  useMountEffect(() => {
    modalManager.setModalState(modal, () => forceUpdate({}));

    return () => {
      modalManager.setModalState(null, null);
    };
  });

  if (!modal.current.component) return;

  const Modal = modal.current.component;

  return <Modal {...modal.current.props} />;
};

export default ModalContainer;

const modalManager = {
  _modal: null,
  _forceUpdate: null,

  setModalState(modal, forceUpdate) {
    this._modal = modal;
    this._forceUpdate = forceUpdate;
  },

  show(component, props) {
    this._modal.current = { component, props };
    this._forceUpdate();
  },

  hide() {
    this._modal.current = { component: null, props: null };
    this._forceUpdate();
  },

  get isShow() {
    return this._modal?.current.component !== null;
  },
};

export { modalManager };
